module.exports = __webpack_public_path__ + "media/components/country-flag/static/pn-82d39620d23f6bdd63ff2d4a2c4366db.svg";